import { RA$ } from '@infl-ts/util-fp-ts';
import { identity, pipe } from 'fp-ts/function';
import * as RA from 'fp-ts/ReadonlyArray';
export var mergeSxProps = function mergeSxProps() {
  for (var _len = arguments.length, sx = new Array(_len), _key = 0; _key < _len; _key++) {
    sx[_key] = arguments[_key];
  }

  return pipe(sx, RA.reduce(identity([]), function (result) {
    var sx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return pipe(result, RA$.isArray(sx) ? RA.concatW(sx) : RA.appendW(sx));
  }));
};